import React from 'react';
import './style.scss';

export default function Divider() {
  return <div className="Divider" />;
}
